import roundMoney from './roundMoney.js'
import isGoldSealProtection from '../products/isGoldSealProtection.js'
import * as constants from 'root-config/constants.js'
import TravelProtectionPlanType from 'root-packages/travelProtection/index.js'

export function applyTravelProtectionToPassengers ({
  options,
  passengers,
  promotions,
  extraAmountPerPassenger = 0,
}) {
  priceTravelProtection(
    options,
    passengers,
    promotions,
    extraAmountPerPassenger
  ).forEach((travelProtection, index) => {
    if (travelProtection) {
      const passenger = passengers[index]
      passenger.travelProtectionProducts = [
        ...(passenger.travelProtectionProducts || []),
        ...travelProtection.travelProtectionProducts,
      ]
      passenger.requestedTravelProtection =
        travelProtection.requestedTravelProtection
      passenger.total += travelProtection.requestedTravelProtection.amount
      passenger.full += travelProtection.requestedTravelProtection.amount
    }
  })
}

function priceTravelProtection (
  priceBreakdownOptions,
  passengers,
  promotions = {amountPerPassenger: {}},
  extraAmountPerPassenger
) {
  return passengers.map((passengerQuote, index) => {
    const passengerPriceForTravelProtection =
      passengerQuote.total +
      extraAmountPerPassenger -
      (promotions.amountPerPassenger[index] && promotions.amountPerPassenger[index].amount || 0) -
      (passengerQuote.requestedPrepaidGratuities?.amount || 0)

    const travelProtectionPlan = priceBreakdownOptions.perPassengerPrices.travelProtectionPlan(
      passengerPriceForTravelProtection,
      passengerQuote.ontarioResident
    )
    const travelProtectionPlanPlus = priceBreakdownOptions.perPassengerPrices.travelProtectionPlanPlus(
      passengerPriceForTravelProtection,
      passengerQuote.ontarioResident
    )
    if (travelProtectionPlan || travelProtectionPlanPlus) {
      passengerQuote.travelProtectionPlan = travelProtectionPlan
      passengerQuote.travelProtectionPlanPlus = travelProtectionPlanPlus
      if (passengerQuote.travelProtection) {
        // true value for compatibility with tests (should I update them all?)
        const _travelProtectionPlan = [TravelProtectionPlanType.standard, true].includes(passengerQuote.travelProtection)
          ? travelProtectionPlan
          : passengerQuote.travelProtection === TravelProtectionPlanType.plus
            ? travelProtectionPlanPlus
            : undefined
        if (!_travelProtectionPlan) {
          return
        }

        const travelProtection = {
          miscProducts: [],
          travelProtectionProducts: [],
        }

        const travelProtectionTax = passengerQuote.ontarioResident
          ? constants.ontarioTravelProtectionTax * _travelProtectionPlan.price
          : 0

        const amount = roundMoney(
          _travelProtectionPlan.price + travelProtectionTax
        )

        if (isGoldSealProtection(_travelProtectionPlan)) {
          travelProtection.miscProducts.push({
            productCode: _travelProtectionPlan.productCode,
            typeCode: _travelProtectionPlan.typeCode,
            totalPrice: amount,
            category: _travelProtectionPlan.category,
          })
        } else {
          travelProtection.travelProtectionProducts.push({
            productCode: _travelProtectionPlan.productCode,
            typeCode: _travelProtectionPlan.typeCode,
            totalPrice: amount,
          })
        }

        travelProtection.requestedTravelProtection = {
          amount,
          basePrice: _travelProtectionPlan.price,
          code: _travelProtectionPlan.productCode,
          productId: _travelProtectionPlan.productId,
          associatedProductId: _travelProtectionPlan.associatedProductId,
          productName: _travelProtectionPlan.productName,
          typeCode: _travelProtectionPlan.typeCode,
          category: _travelProtectionPlan.category,
          miscserviceid: _travelProtectionPlan.miscserviceid,
        }

        return travelProtection
      }
    }
  })
}